import { createAsyncThunk } from '@reduxjs/toolkit';
import { getInvoiceScanningAddress } from '../services/getInvoiceScanningAddress';

export const loadInvoiceScanningAddress = createAsyncThunk(
  'invoices/invoiceScanningAddress',
  async (params, { getState, dispatch }) => {
    const businessId = params.businessId;
    if (!businessId) {
      throw new Error('Business ID is required');
    }

    const response = await getInvoiceScanningAddress(businessId);

    return response;
  }
);
